<template>
  <el-collapse
    class="mt-20"
    v-if="assignments"
    v-model="activeCollapse"
  >
    <el-collapse-item
      v-for="(assignment, index) in assignments"
      :key="index"
      :class="(assignment.employee.empStatus === 'Waiting confirmation') ? 'unconfirmed' : 'confirmed'"
    >
      <template slot="title">
        <img
          :src="`https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${assignment.businessEntity.logo || 'profile.png'}?t=${new Date().getTime()}`"
          width="40px"
          height="40px"
        >
        <div class="title">
          <p class="phone">
            {{ assignment.employee.phoneNum }}
          </p>
          <p class="team-name truncate">
            {{ assignment.businessEntity.name }} ({{ assignment.team.name }})
          </p>
        </div>
      </template>
      <div class="rows-wrapper">
        <div class="row">
          <span class="property">{{ $t('profile.email') }}</span>
          <span class="value">{{ assignment.employee.email }}</span>
        </div>
        <div class="row">
          <span class="property">QR Code</span>
          <span class="value">{{ assignment.employee.qrCode }}</span>
        </div>
        <div class="row">
          <span class="property">Create Date</span>
          <span class="value">{{ formatDate(assignment.employee.created) }}</span>
        </div>
      </div>
      <el-button
        v-if="assignment.employee.empStatus === 'Waiting confirmation'"
        type="success"
        class="success-button"
        @click="confirmUserAssign(index)"
      >
        {{ $t('form.confirm') }}
      </el-button>
      <el-button
        v-else
        type="primary"
        class="primary-button"
        @click="confirmUnassignDialogVisible = true; selectedAssignment = assignment"
      >
        {{ $t('form.unassign') }}
      </el-button>
    </el-collapse-item>
    <el-dialog
      :title="$t('form.unassign')"
      :visible.sync="confirmUnassignDialogVisible"
      width="330px"
      :center="true"
      :show-close="false"
      :append-to-body="true"
      class="confirm-dialog"
      @close="selectedAssignment = {businessEntity: {name: ''}}"
    >
      <span class="confirm-dialog-title">
        {{ $t('form.confirm-unassign', { company: selectedAssignment.businessEntity.name }) }}
      </span>
      <span
        slot="footer"
      >
        <el-row>
          <el-button
            type="primary"
            @click="unassignEmployee(selectedAssignment)"
            class="primary-button"
          >
            {{ $t('yes') }}
          </el-button>
        </el-row>
        <el-row class="mt-20">
          <el-button
            type="text"
            @click="confirmUnassignDialogVisible = false"
            class="primary-link"
          >
            {{ $t('no') }}
          </el-button>
        </el-row>
      </span>
    </el-dialog>
  </el-collapse>
</template>

<script>
import { Auth } from '@aws-amplify/auth'
import moment from 'moment';

export default {
  name: 'Assignments',
  data: () => ({
    assignments: [],
    activeCollapse: [],
    confirmUnassignDialogVisible: false,
    selectedAssignment: {
      businessEntity: {
        name: ''
      }
    }
  }),
  created () {
    Auth.currentAuthenticatedUser().then((user) => {
      this.$adminApi.get('/api/v1/employees/' + user.attributes.sub).then((response) => {
        this.assignments = response.data;
      });
    });
  },
  methods: {
    formatDate (value) {
      return moment(value).format('DD.MM.YYYY');
    },
    unassignEmployee (assignment) {
      const index = this.assignments.findIndex((el) => {
        return el.employee.qrCode === assignment.employee.qrCode;
      });
      this.$adminApi.put('/api/v1/employees/' + assignment.employee.id + '/unassign').then((response) => {
        if (response.data.status === 'Success') {
          this.$message.success(this.$t('teams.unassigned'));
          this.assignments.splice(index, 1);
          this.activeCollapse = [];
          this.confirmUnassignDialogVisible = false;
        } else {
          this.$message.warning(response.data.status);
        }
      });
    },
    confirmUserAssign (index) {
      this.$adminApi.put('/api/v1/employees/' + this.assignments[index].employee.id + '/confirm').then((response) => {
        if (response.data.status === 'Success') {
          this.assignments[index].employee = response.data.payload;
        } else {
          this.$message.warning(this.$t('teams.can-not-confirm-assignment'));
        }
      }).catch(() => {
        this.$message.error(this.$t('form.something-wrong'));
      });
    }
  }
};
</script>

<style scoped lang="scss">

</style>
